import { defineStore } from "pinia";
import { getDepartments, saveDepartments } from "../utils/ProjectUtils";
import type { Department, Project } from "../types/PersologOnlineTypes";

export const useProjectDepartmentsStore = defineStore("projectDepartments", {
    state: () => ({
        departmentsByProject: {} as Record<number, Department[]>,
    }),
    actions: {
        async ensureLoaded(project: Project) {
            if (project.id === undefined || project.id in this.departmentsByProject) return;
            this.departmentsByProject[project.id] = await getDepartments(project);
        },
        getForProject(projectId: number): Department[] {
            return this.departmentsByProject[projectId] ?? [];
        },
        set(projectId: number, departments: Department[]) {
            this.departmentsByProject[projectId] = [...departments];
        },
        async save(project: Project, departments: Department[]) {
            const savedDepartments = await saveDepartments(project, departments);
            if (project.id !== undefined) {
                this.departmentsByProject[project.id] = [...(savedDepartments ?? departments)];
            }
        },
    },
});
